<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="supplement-type-list content-wrapper">
      <div class="page-header">{{ $t('supplementType') }}</div>
      <div>
        <el-row>
          <el-col :span="4">
            <el-input :placeholder="$t('keyword')"
                      v-model="keyword"
                      @input="isSearching = true"></el-input>
          </el-col>
          <el-col :span="20">
            <el-button style="float: right;" type="primary" icon="el-icon-plus" @click="onAddButtonClick">{{ $t('newSupplementType') }}</el-button>
          </el-col>
        </el-row>
        <div style="margin-top: 25px">
          <el-table
            id="supplement-type-list-table"
            :data="supplementTypeListDataSource"
            :default-sort = "{prop: 'name', order: 'ascending'}"
            v-loading="isSearching"
            header-row-class-name="table-header-color"
            style="width: 100%">
            <el-table-column
              prop="name"
              :label="$t('name')">
            </el-table-column>
            <el-table-column align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" icon="el-icon-edit" plain circle @click="onEditButtonClick(scope.row)"></el-button>
                <el-button type="danger" size="small" icon="el-icon-delete" plain circle @click="onRemoveButtonClick(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Hotel/ManageHotel/Supplement/ManageSupplement/Type/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import HotelSupplementTypeApi from '@/api/hotel/supplement-type-api'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { filterDataByKeyword } from '@/services/general-service'
import { mapState } from 'vuex'
import { getHotelIndexRoute } from '@/services/hotel-service'
import { debounce } from 'lodash'

export default {
  name: 'HotelSupplementTypeList',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  created: async function () {
    if (this.activeHotelId === undefined || this.activeHotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    try {
      this.isLoading = true
      this.supplementTypeList = await HotelSupplementTypeApi.list(this.activeHotelId)
      this.getSupplementTypeListDataSource()
    } catch (err) {
      this.alertError(err.message)
    }

    this.isLoading = false
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  watch: {
    keyword: debounce(function () {
      this.isSearching = false
    }, 300),
    isSearching: function (value) {
      if (!value) {
        this.getSupplementTypeListDataSource()
      }
    }
  },
  data () {
    return {
      isLoading: true,
      keyword: '',
      isSearching: false,
      supplementTypeList: [],
      supplementTypeListDataSource: []
    }
  },
  methods: {
    getSupplementTypeListDataSource: function () {
      const searchKeys = ['name']
      const filteredSupplementTypeList = filterDataByKeyword(this.supplementTypeList, this.keyword, searchKeys)
      this.supplementTypeListDataSource = [...filteredSupplementTypeList]
    },
    onAddButtonClick: function () {
      this.$router.push({
        name: 'HotelSupplementTypeAdd'
      })
    },
    onEditButtonClick: function (supplementType) {
      this.$router.push({
        name: 'HotelSupplementTypeEdit',
        params: {
          supplementType: supplementType
        }
      })
    },
    onRemoveButtonClick: async function (supplementType) {
      const confirmMessage = this.$t('confirmRemoveSupplementTypeMessage', {
        supplementTypeName: supplementType.name
      })
      const confirmButtonText = this.$t('confirmButtonText')
      const cancelButtonText = this.$t('cancelButtonText')
      const isConfirmRemove = await this.alertConfirmDelete(confirmMessage, confirmButtonText, cancelButtonText)

      if (!isConfirmRemove) {
        return false
      }

      this.removeSupplementType(supplementType.id)
    },
    removeSupplementType: async function (supplementTypeId) {
      try {
        this.startLoading()

        await HotelSupplementTypeApi.remove(this.activeHotelId, supplementTypeId)

        this.supplementTypeList = this.supplementTypeList.filter(item => item.id !== supplementTypeId)
        this.getSupplementTypeListDataSource()

        const notificationTitle = this.$t('removeSupplementTypeSuccess')
        this.showNotificationSuccess(notificationTitle)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    }
  }
}
</script>

<style scoped>
  #supplement-type-list-table {
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 5px;
    box-shadow: 0px 3px 5px 1px #eeeeee;
  }
  .el-table th {
    background-color: #eeeeee;
  }
  .el-form > div {
    text-align: left;
  }
</style>
